var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#438CCB;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_00000062899593816722365280000006708337254503553416_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 30,
    height: 30
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000009561168888354123400000014637862542169684130_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.6,27.8V15.4H6.2c-0.9,0-1.5-1.1-0.9-1.8l8.8-11c0.2-0.3,0.6-0.4,0.9-0.4s0.6,0.1,0.9,0.4l8.8,11 c0.6,0.7,0.1,1.8-0.9,1.8h-3.4v12.4H9.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up_arrow.1566acf9a83a55afe0ca144441df1093.svg";
export { ForwardRef as ReactComponent };